<template>
  <header class="mondelez-header">
    <div class="container text-center">
      <img src="../assets/Logo-Mondelez.svg" alt="Mondelez Logo" class="logo-img" />
    </div>
  </header>
</template>

<style scoped>
.mondelez-header {
  background: linear-gradient(90deg, #4c1c8c, #7200b8); 
  padding: 20px 0;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.logo-img {
  max-height: 70px;
  height: auto;
}
</style>